<template>
  <div id="LandingPageStatic">
    <MainLogo />
    <Hero src="../../../assets/landing-static/hero.jpg">
      <Row>
        <Column :lg="7" />
        <Column :lg="5">
          <h1 class="title">
            {{ $t('title') | lineBreak }}
          </h1>
          <div class="hero-side-text">
            <p>{{ $t('side') }}</p>
          </div>
        </Column>
      </Row>
      <!-- <HeroScrollDown slot="outside" hash="#contact" :label="$t('heroScroll')" /> -->
    </Hero>
    <SectionWhySolarLanding />
    <SectionPortfolio :media="portfoliosMedia" />
    <SectionHowItWorks />
    <Calculator />
    <SectionOptimisedTraditional />
    <SectionGuarantees />
    <SectionWhyWorth />
    <SectionFaq doShowAllQuestions :faqs="$ta('faq')" />
    <div id="contact">
      <FooterContact />
    </div>
    <FooterLanding />
  </div>
</template>

<script>
import Calculator from 'views/components/Calculator'
import FooterContact from 'views/components/FooterContact'
import FooterLanding from 'views/components/FooterLanding'
import Hero from 'views/components/Hero'
// import HeroScrollDown from 'views/components/HeroScrollDown'
import MainLogo from 'views/components/TopBar/MainLogo'
import Meta from 'views/mixins/Meta'
import SectionFaq from 'views/components/SectionFaq'
import SectionGuarantees from 'views/components/SectionGuarantees'
import SectionHowItWorks from 'views/components/SectionHowItWorks'
import SectionOptimisedTraditional from 'views/components/SectionOptimisedTraditional'
import SectionPortfolio from './components/SectionPortfolio'
import SectionWhySolarLanding from './components/SectionWhySolarLanding'
import SectionWhyWorth from './components/SectionWhyWorth'
import { actions } from '../../utils'

export default {
  mixins: [
    Meta(
      require('@/assets/social/landing-page.jpg'),
    ),
  ],
  components: {
    MainLogo,
    Calculator,
    Hero,
    // HeroScrollDown,
    SectionWhySolarLanding,
    SectionPortfolio,
    SectionHowItWorks,
    SectionOptimisedTraditional,
    SectionGuarantees,
    SectionWhyWorth,
    SectionFaq,
    FooterLanding,
    FooterContact,
  },
  computed: {
    portfolios() {
      return this.query('portfolio')
    },
    portfoliosMedia() {
      return this.portfolios.map(portfolio => portfolio.media)
    },
  },
  methods: actions('FETCH_PORTFOLIO'),
  created() {
    this.LOAD(this.FETCH_PORTFOLIO())
  },
}

</script>

<style lang="scss">
#LandingPageStatic {
  .MainLogo {
    padding: 1rem 0 0 2rem;
    position: absolute;
    z-index: 2;
  }

  .Hero {
    h1 {
      text-align: left;

    }

    .image img {
      filter: brightness(0.8);
      height: 100%;
    }
  }

  .title {
    padding-bottom: 2rem;
  }
}
</style>

<i18n>
{
  "lt": {
    "title": "Saulės elektrinė iš patyrusių rankų",
    "side": "Inovatyvūs, patikimi ir kokibę vertinantys saulės elektrinių rangovai. Savo veiklą Lietuvoje pradėjome 2016 metais. Nuo tada subūrėme dešimties saulės energetikos ekspertų komandą, kuri jau įgyvendino daugiau nei 700 projektų",
    "heroScroll": "Gauti pasiūlymą",
    "faq": [
      {
        "question": "Kokios galios saulės elektrinę pasirinkti?",
        "answer": "Tinkamos galios elektrinė garantuos efektyvų energijos generavimą. Vidutiniškai 1 kW pagamina 1000 kWh/metus. Jeigu Jūsų namų ūkis per metus suvartoja 8000 kWh, Jums reikalinga maždaug 8 kW galios elektrinė."
      },
      {
        "question": "Koks stogas yra tinkamiausias saulės elektrinei?",
        "answer": "Saulės elektrinę galima sumontuoti ir ant plokščio, ir ant šlaitinio tipo stogo. Idealus šlaitinio stogo nuolydžio kampas yra 30-40 laipsnių, kryptis – pietūs. Net ir modulius pakreipus į rytų ar vakarų pusę, moduliai generuoja apie 75 proc. savo maksimalaus pajėgumo."
      },
      {
        "question": "Kokių gamintojų įrangą galiu įsigyti?",
        "answer": "Savo partneriais pasirinkome pasaulinės rinkos lyderius. Mūsų siūlomi saulės moduliai – „Suntech“ (Kinija). Įtampos keitikliai (inverteriai) – „Solar Edge“ (Izraelis), „Huawei“ (Kinija). Montavimo medžiagas, kurioms suteikiama 10-ies metų garantija, renkamės iš aliuminio ir kitų medžiagų. Šias medžiagas tiekia „Aero Compact“ (Vokietija), „Profiness“ (Vokietija), kurie jau du dešimtmečius gamina saulės elektrinių montavimo įrangą."
      }
    ]
  }
}
</i18n>
